<script setup lang="ts">
/**
 * CctvContextSwitcher
 *
 * Segmented toggle that lets visitors switch between Commercial and Residential CCTV pages.
 * Rendered below the hero on both /security-services/cctv and /security-services/residential-cctv.
 * Follows the "Segmented toggle group" pattern from design-guide.md.
 */

const route = useRoute()

const isCommercial = computed(() => route.path === '/security-services/cctv')
const isResidential = computed(() => route.path === '/security-services/residential-cctv')
</script>

<template>
  <nav aria-label="CCTV page type" class="bg-white py-4">
    <div class="mx-auto flex max-w-7xl justify-center px-4 sm:px-6 lg:px-8">
      <div class="inline-flex rounded-full border border-neutral-200 bg-white p-1 gap-1">
        <NuxtLink
          to="/security-services/cctv"
          :aria-current="isCommercial ? 'page' : undefined"
          :class="[
            'rounded-full px-4 py-1.5 text-sm font-medium transition-colors',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2',
            isCommercial
              ? 'bg-primary-500 text-white font-semibold shadow-sm'
              : 'text-slate-700 hover:bg-neutral-50',
          ]"
        >
          Commercial CCTV
        </NuxtLink>
        <NuxtLink
          to="/security-services/residential-cctv"
          :aria-current="isResidential ? 'page' : undefined"
          :class="[
            'rounded-full px-4 py-1.5 text-sm font-medium transition-colors',
            'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2',
            isResidential
              ? 'bg-primary-500 text-white font-semibold shadow-sm'
              : 'text-slate-700 hover:bg-neutral-50',
          ]"
        >
          Residential CCTV
        </NuxtLink>
      </div>
    </div>
  </nav>
</template>
